import { useEffect } from 'react';
import { eventSubscription } from '../../../utils/events/eventSubscription';
import { useApplicationCallbacks } from '../../../providers/application-callbacks';
import { useAppState, useGamesSettings } from '../../../redux/reducer/content';

export default function useHandleCanvasLostError() {
  const gamesSettings = useGamesSettings();
  const state = useAppState();
  const { returnAttempts } = useApplicationCallbacks();

  useEffect(
    () =>
      eventSubscription({
        callbacksBus: [
          {
            event: 'webglcontextlost',
            callback({ detail: libraryType }) {
              if (gamesSettings) {
                const currentGame = getGameNameNyState(state);
                if (currentGame) {
                  const returnedEnergy = gamesSettings?.find?.(({ name }) => name === currentGame)?.energy;
                  returnAttempts(returnedEnergy);
                }
              }

              setTimeout(() => {
                throwCanvasLostError(libraryType);
              }, 2000); // Чтобы успел отправиться запрос
            },
          },
        ],
      }),
    [state, gamesSettings, returnAttempts],
  );
}

class CanvasLostError extends Error {
  constructor(info) {
    super('CanvasLostError');
    this.stack = info;
  }
}

function throwCanvasLostError(info) {
  throw new CanvasLostError(info);
}

const states = {
  memories: 'Memories',
  platform: 'Match3',
  jumper: 'Runner',
  match3: 'Jumper',
};

function getGameNameNyState(state) {
  return states[state];
}
